export default __webpack_public_path__ + "static/media/plain-sticker-ed.ce4cc2a0.png";